import React from 'react'

export default function FindTicket() {
  return (
    <div>FindTicket</div>
  )
}
